import React, { useEffect, useState } from "react";
import {
  updateFormContentPreview,
  getFormContentPreview,
  imageUploadClientPreview,
} from "../../../../api/services/services";
import { Button, Snackbar } from "@mui/material";
import Typography from "@mui/material/Typography";
import { Row, Col } from "react-bootstrap";
import MuiAlert from "@mui/material/Alert";
import { Bucket } from "../../../../api/config/apiConfig";
import Input from "../../../atoms/Input";
import TextArea from "../../../atoms/Textarea";
import ContactDetailField from "../../../molecules/ContactDetailField";
import { useLocation } from "react-router-dom";
import generatePDF, { Resolution, Margin } from "react-to-pdf";
// import QuotationFormDownload from "./download";
import html2pdf from "html2pdf.js";
import DynamicCheckbox from "../../../molecules/DynamicCheckbox";
import DynamicText from "../../../molecules/DynamicText";

const PackingRequestPageDownload = ({ formContent, surveyData }) => {
  const [isEdit, setIsEdit] = useState(false);

  const getOrdinalSuffix = (day) => {
    if (day > 3 && day < 21) return "th"; // 11th, 12th, 13th, etc.
    switch (day % 10) {
      case 1:
        return "st";
      case 2:
        return "nd";
      case 3:
        return "rd";
      default:
        return "th";
    }
  };

  // Helper function to format the date
  const formatDate = (dateString) => {
    const date = new Date(dateString);

    const day = date.getDate();
    const month = date.toLocaleString("default", { month: "long" });
    const year = date.getFullYear();

    const ordinalSuffix = getOrdinalSuffix(day);

    return `${day}${ordinalSuffix} ${month}, ${year}`;
  };

  return (
    <div className="premium-print-container">
      <div className="section-divider">
        <h1 className="section-title">PACKING REQUEST</h1>
      </div>

      <div className="data-grid">
         <div className="data-item">
          <span className="data-label">Customer Name</span>
          <span className="data-value">{formContent?.customerName || "-"}</span>
        </div>
         <div className="data-item">
          <span className="data-label">Date</span>
          <span className="data-value">{formContent?.date ? formatDate(formContent?.date) : "-"}</span>
        </div>
      </div>

       <div className="data-grid" style={{ gridTemplateColumns: '1fr', marginTop: '10px' }}>
         <div className="data-item">
          <span className="data-label">Packing Address</span>
          <span className="data-value">{formContent?.packingAddress || "-"}</span>
        </div>
      </div>

      <div className="data-grid" style={{ gridTemplateColumns: '1fr', marginTop: '10px' }}>
         <div className="data-item">
          <span className="data-label">Preferred Packing Date & Time</span>
          <span className="data-value">
             {formContent?.packingDate ? (
                <>
                  {formatDate(formContent?.packingDate)} {" - "}{" "}
                  {formContent?.packingTime}
                </>
              ) : (
                "-"
              )}
          </span>
        </div>
      </div>

      <div style={{ marginTop: '20px' }}>
        <h2 className="section-title" style={{ fontSize: '10pt', borderBottom: '1px solid #ddd', paddingBottom: '5px' }}>PERMISSIONS & REQUIREMENTS</h2>
        
        <div className="data-grid" style={{ gridTemplateColumns: '1fr', marginTop: '10px' }}>
             <div className="data-item">
                <span className="data-label">Is permission/permit required?</span>
                <span className="data-value">{formContent?.permissions ? "YES" : "NO"}</span>
             </div>
             {formContent?.permissions && (
               <div className="data-item">
                  <span className="data-label">Requirement Details</span>
                  <span className="data-value">{formContent?.adviseRequirement || "-"}</span>
               </div>
             )}
        </div>
      </div>

       <div style={{ marginTop: '20px' }}>
        <h2 className="section-title" style={{ fontSize: '10pt', borderBottom: '1px solid #ddd', paddingBottom: '5px' }}>PRIORITY ITEMS</h2>
        
        <div className="data-grid" style={{ gridTemplateColumns: '1fr', marginTop: '10px', gap: '15px' }}>
             <div className="data-item">
                <span className="data-label">1st Priority</span>
                <span className="data-value">{formContent?.firstPriority || "-"}</span>
             </div>
             <div className="data-item">
                <span className="data-label">2nd Priority</span>
                <span className="data-value">{formContent?.secondPriority || "-"}</span>
             </div>
              <div className="data-item">
                <span className="data-label">3rd Priority</span>
                <span className="data-value">{formContent?.thirdPriority || "-"}</span>
             </div>
        </div>
      </div>

      <div className="data-grid" style={{ gridTemplateColumns: '1fr', marginTop: '20px' }}>
             <div className="data-item">
                <span className="data-label">Items marked NOT to pack?</span>
                <span className="data-value">{formContent?.packUpSuitable ? "YES" : "NO"}</span>
             </div>
      </div>

       <div className="data-grid" style={{ gridTemplateColumns: '1fr', marginTop: '10px' }}>
             <div className="data-item">
                <span className="data-label">Customer Suggestions/Remarks</span>
                <span className="data-value">{formContent?.suggestions || "-"}</span>
             </div>
             <div className="data-item">
                <span className="data-label">Office Instructions/Remarks</span>
                <span className="data-value">{formContent?.officeInstructions || "-"}</span>
             </div>
      </div>

      <div style={{ display: 'flex', marginTop: '40px', gap: '40px' }}>
          <div style={{ flex: 1, textAlign: 'center' }}>
            <div style={{ height: '80px', display: 'flex', alignItems: 'flex-end', justifyContent: 'center', marginBottom: '10px' }}>
              {formContent?.moveCordinatorSign && (
                <img src={`${Bucket}${formContent?.moveCordinatorSign}`} height={80} style={{ objectFit: 'contain' }} />
              )}
            </div>
            <div style={{ borderTop: '1px solid #000', paddingTop: '5px', fontWeight: 700 }}>Move Coordinator</div>
          </div>

          <div style={{ flex: 1, textAlign: 'center' }}>
            <div style={{ height: '80px', display: 'flex', alignItems: 'flex-end', justifyContent: 'center', marginBottom: '10px' }}>
              {formContent?.clientSign && (
                <img src={`${Bucket}${formContent?.clientSign}`} height={80} style={{ objectFit: 'contain' }} />
              )}
            </div>
            <div style={{ borderTop: '1px solid #000', paddingTop: '5px', fontWeight: 700 }}>Client Signature</div>
          </div>
        </div>

    </div>
  );
};
export default PackingRequestPageDownload;
